import React from 'react'

function Footer() {
  return (
    <div>
      <footer className="bg-dark text-light text-center py-3 mt-auto">
        © 2025 Powered By Burn
      </footer>
    </div>
  )
}

export default Footer